module.exports = __webpack_public_path__ + "static/media/server_down.8ca25410.png";